import type { GenericEventName, GenericEventParams, GenericEventTag } from '../types/logging';

import { interviewPrepNativeModule } from '../native-modules/InterviewPrepNativeModule';
import { toSnakeCase } from '../util/stringUtils';

type LogInterviewPrepGenericEventOptions = {
    eventName: GenericEventName;
    params: GenericEventParams;
    tags?: GenericEventTag[];
    commonEventName?: string;
    eventType?: string;
    eventVersion?: number;
};

export async function logInterviewPrepGenericEvent({
    eventName,
    commonEventName = toSnakeCase(eventName),
    params,
    tags = ['interviewPrep'],
    eventType = 'other',
    eventVersion = 1,
}: LogInterviewPrepGenericEventOptions) {
    console.info('Logging event:', eventName, 'params:', params);
    const module = interviewPrepNativeModule();
    if (module?.logInterviewPrepEvent) {
        await module.logInterviewPrepEvent(
            commonEventName,
            eventType,
            eventName,
            eventVersion,
            tags,
            params,
        );
    }
}
